module.exports = {"id":"211117","name":"Dele Alli","rating":"84","photo":"./data/images/photos/3/211117.png","club":{"name":"Tottenham Hotspur","logo":"./data/images/clubs/TottenhamHotspur.png"},"positions":["MOC","ATT"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DeleAlli0.json
// module id = 1038
// module chunks = 0